import { Component, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

@Component({
    selector: 'item-body',
    template: require('./item-body.component.html')
})
export class ItemBodyComponent implements AfterViewInit, OnDestroy {
    @Input() assessmentItem$: Observable<PgRendererDto.AssessmentItem>;

    assessmentItem: PgRendererDto.AssessmentItem;
    assessmentItemSubscription: Subscription;
    leftPane: PgRendererDto.ItemBodyPanel;
    rightPane: PgRendererDto.ItemBodyPanel;
    mainPane: PgRendererDto.ItemBodyPanel;
    rightPaneHeight: number;
    rightPaneTop: number;
    showTab: boolean = false;

    ngAfterViewInit() {
        this.assessmentItemSubscription = this.assessmentItem$.subscribe(assessmentItem => {
            this.assessmentItem = assessmentItem;
            if (this.assessmentItem) {
                this.leftPane = this.assessmentItem.ItemBody.ItemBodyPanels.find(x => x.CssClass.indexOf("leftpane") >= 0);
                this.rightPane = this.assessmentItem.ItemBody.ItemBodyPanels.find(x => x.CssClass.indexOf("rightpane") >= 0);
                this.mainPane = this.assessmentItem.ItemBody.ItemBodyPanels.find(x => x.CssClass.indexOf("mainpane") >= 0);
            }

            if (this.assessmentItem && this.assessmentItem.DisplayPageNumber) {
                this.showTab = true;
            } else {
                this.showTab = false;
            }
        });
    }

    ngOnDestroy() {
        if (this.assessmentItemSubscription) {
            this.assessmentItemSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body.component.ts